import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';

const SignOutModal = ({shouldShow, onSignOut, onClose}) => {

  	return (
		<>
			<Modal  show={shouldShow} centered onHide={onClose} style={{color:'white'}}>
				<Modal.Header closeButton >
					<Modal.Title>Sign Out</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<p>Are you sure you want to sign out?</p>
				</Modal.Body>
				
				<Modal.Footer>
				<Button onClick={() => onClose()} variant='secondary' style={{color:'black', background:'#8A8B87'}}>
					Cancel
				</Button>
				<Button onClick={() => onSignOut()} style={{color:'black', marginRight:10}}>
					Sign Out
				</Button>
				</Modal.Footer>
			</Modal>
		</>
		
  	);
}

export default SignOutModal;